<template lang="html">
  <div>
    <div class="search">
      <cm-messages-filter
        class=""
        style="position:relative;z-index:10"
        :isPayments="true"
        :received="false">
      </cm-messages-filter>

        <dp-transactions-list
          :filterBy="filterBy"
          v-bind:outMessages="sendboxMessages">
        </dp-transactions-list>
        <cm-pagination
          :firstIndex="sendPaginationObject.firstIndex"
          :maxResultsByPage="sendPaginationObject.maxResults"
          :nbResultsTotal="sendPaginationObject.nbResultsTotal"
          :refreshEvent="sendPaginationObject.refresh"
          >
        </cm-pagination>
        <div class="toolbarPageBottomBlank"></div>

      </div>
  </div>
</template>

<script>
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import MessagesFilter from '@/components/common/Filter.vue'
import pagination from '@/components/common/pagination.vue'
import {errorMessageAlert} from '@/helpers/alert'
import moment from 'moment'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'sent-dp',
  components: {
    'dp-transactions-list': TransactionsList,
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination
  },
  data () {
    return {
      sendboxMessages: [],
      filterBy: '',
      sendPaginationObject: {}
    }
  },
  created () {
    // Initialisation du sendPaginationObject
    let that = this
    that.sendPaginationObject['firstIndex'] = 1
    that.sendPaginationObject['maxResults'] = 10
    that.sendPaginationObject['nbResultsTotal'] = 0
    that.sendPaginationObject['refresh'] = 'direct-sendbox-filtered'
    that.sendboxMessages = []
    that.$engine.settings.set({msgDirection: 1})
    this.$bus.$on('direct-sendbox-filtered', index => {
      that.onRefresh(index)
    })
    this.onRefresh()
  },
  beforeDestroy () {
    let that = this
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
    that.$engine.services.directPayments.filter.cleanFilterCondition()
  },
  methods: {
    extractCSV () {
      let firstLine = 'NbStatus;Status;remittanceInformation;attachmentId;creditorName;creationDate\r\n'
      let lines = ''
      const that = this
      this.sendPaginationObject.firstIndex = 1
      this.$f7.showPreloader('Extracting Direct Payments')
      that.$engine.services.directPayments.update(
        1,
        this.sendPaginationObject.nbResultsTotal,
        this.sendPaginationObject.firstIndex,
        that.$engine.services.directPayments.filter.getConditionObject()
      ).then(resp => {
        let sendboxMessagesCSV = resp.data.directPayments
        for (let datas in sendboxMessagesCSV) {
          lines += sendboxMessagesCSV[datas]['status'] + ';' +
          TransactionsList.methods.getStatusLabel(sendboxMessagesCSV[datas]['status'], sendboxMessagesCSV[datas]['negotStatus'], 1) + ';' +
          sendboxMessagesCSV[datas]['remittanceInformation'] + ';' +
          sendboxMessagesCSV[datas]['attachmentId'] + ';' +
          sendboxMessagesCSV[datas]['creditorName'] + ';' +
          sendboxMessagesCSV[datas]['creationDate'] + '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        let today = moment()
        const linkSource = 'data:text/csv;charset:utf-8,' + data
        const downloadLink = document.createElement('a')
        const fileName = 'sentDirectPayments' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh: function (index = 1) {
      const that = this
      this.sendPaginationObject.firstIndex = index
      this.$f7.showIndicator()
      that.$engine.services.directPayments.update(
        1,
        this.sendPaginationObject.maxResults,
        this.sendPaginationObject.firstIndex,
        that.$engine.services.directPayments.filter.getConditionObject()
      ).then(resp => {
        that.$f7.hideIndicator()
        this.sendPaginationObject.nbResults = resp.data.directPayments.length
        this.sendPaginationObject.nbResultsTotal = parseInt(resp.data.totalDirectPayments)
        this.updateSendbox(resp.data.directPayments)
        /* console.log('premier appel dans la vue')
        console.log(this.sendPaginationObject) */
        that.$bus.emit('refresh-cache-paging-template', this.sendPaginationObject)
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    updateSendbox (directPayments, noAttach = false) {
      this.sendboxMessages = directPayments
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    onClear: function (event) {
      this.filterBy = ''
    },
    openCreateRequest () {
      loadPage(this, {url: '/directPayments/creation/'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// SentDP.vue?4849da86